import styled from 'styled-components';
import { Box } from '@rsos/base-components';

const toBlurOrNotToBlur = isBlurred => {
  if (isBlurred) {
    return `
        filter: blur(8px);
        -webkit-filter: blur(8px);
      `;
  }
};

export const BlurOverflowContainer = styled(Box).attrs({
  overflow: 'hidden', // prevents the blur from bleeding
})``;

export const BlurContainer = styled(Box)`
  ${({ isBlurred }) => toBlurOrNotToBlur(isBlurred)};
`;

export const IconWrapper = styled(Box)`
  margin-right: 8px;
`;
